import { Validator } from '@vista-digital/validator';
import { LoyaltyAuthenticationType } from './loyalty-authentication-type';
import { LoyaltyMemberIdentifier, loyaltyMemberIdentifierValidator } from './loyalty-member-identifier';
export const defaultLoyaltyAuthenticationConfig = {
    type: LoyaltyAuthenticationType.Cookie,
    memberIdentifier: LoyaltyMemberIdentifier.Email
};
export const loyaltyAuthenticationConfigTokenValidator = Validator.object({
    type: Validator.isEqualTo(LoyaltyAuthenticationType.Token),
    memberIdentifier: loyaltyMemberIdentifierValidator,
    getToken: Validator.fn(),
    setToken: Validator.fn()
});
export const loyaltyAuthenticationConfigCookiesValidator = Validator.object({
    type: Validator.isEqualTo(LoyaltyAuthenticationType.Cookie),
    memberIdentifier: loyaltyMemberIdentifierValidator
});
export const loyaltyAuthenticationConfigWorkstationCookiesValidator = Validator.object({
    type: Validator.isEqualTo(LoyaltyAuthenticationType.WorkstationCookie),
    memberIdentifier: loyaltyMemberIdentifierValidator
});
export const loyaltyAuthenticationConfigValidator = Validator.any([
    loyaltyAuthenticationConfigTokenValidator,
    loyaltyAuthenticationConfigCookiesValidator,
    loyaltyAuthenticationConfigWorkstationCookiesValidator
]);
//# sourceMappingURL=loyalty-authentication.js.map